<template>
  <!-- <v-app style="background:linear-gradient(45deg, #0086FE 0%, #54AFF3 100%)"> -->
  <!-- <v-app style="background-color:#2699FB"> -->
<v-app style="background-color: #424242">

<!--bar -->

<v-app-bar
      v-if="showNav"
      app
      color="white"
      flat
      elevation="5"
      height="90%"
    >

    

    <v-container class="py-0 fill-height">
       

        <v-btn
          v-for="link in links"
          :key="link"
          text
        >
          {{ link }}
        </v-btn>
        
        <v-spacer></v-spacer>

        

        <v-responsive max-width="350">
          <v-row>
            
            <v-col cols=9>
          <v-select 
          v-if="sites.length > 1"
          v-model="site"
          :items="sites"
          item-text="name"
          label="Select Camera"
          outlined
          return-object
          
          
        ></v-select>
            </v-col>

            <v-col cols=3>
              <v-btn icon color="grey" @click="logout()"><v-icon>mdi-logout</v-icon></v-btn> 
            </v-col>
          </v-row>
          
        </v-responsive>
      </v-container>
    </v-app-bar>

<!-- content -->

<v-main class="grey darken-3">
      <v-container>
        <v-row>
          

          <v-col>
            <v-sheet
              max-height="75%"
              rounded="lg"
              color="grey darken-3"
            >
              <router-view></router-view>
              <!--  -->
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

<!-- MENU !-->



    <v-navigation-drawer temporary v-model="drawer" app v-if="showNav" >
      <v-list class="pa-0 ma-0">
        
        <v-list-item-group
        v-model="selectedItem"
        color="#2699FB"
      >

      <v-app-bar-nav-icon height="48px" width="48px" class="ml-1" @click="drawer = false" ></v-app-bar-nav-icon>

      <v-divider></v-divider>
      
      <v-list-item @click="$router.push('/')">

        <v-list-item-icon>
          <v-icon class="grey--text text--darken-1">mdi-view-dashboard</v-icon>
        </v-list-item-icon>

        <v-list-item-title class="body-2 grey--text text--darken-1">Dashboard</v-list-item-title>

      </v-list-item>

      <v-divider></v-divider>

      <v-list-group no-action :value="false" prepend-icon="mdi-bulletin-board grey--text text--darken-1">

        <template v-slot:activator>
          <v-list-item-title class="body-2 grey--text text--darken-1">Sites</v-list-item-title>
        </template>

        <v-list-item>

          <v-list-item-content @click="$router.push('/sites')">
            <v-list-item-title class="body-2 grey--text text--darken-1">My Sites</v-list-item-title>
          </v-list-item-content>

          <v-list-item-icon>
            <v-icon dense class="grey--text text--darken-1">mdi-book-open</v-icon>
          </v-list-item-icon>

        </v-list-item>

        <v-list-item>

          <v-list-item-content @click="$router.push('/sites')">
            <v-list-item-title class="body-2 grey--text text--darken-1">Create Site</v-list-item-title>
          </v-list-item-content>

          <v-list-item-icon>
            <v-icon dense class="grey--text text--darken-1">mdi-hammer-screwdriver</v-icon>
          </v-list-item-icon>

        </v-list-item>

        
      </v-list-group>


      </v-list-item-group>
        
      </v-list>

    </v-navigation-drawer>



<!-- HEADER !-->



    <v-app-bar app absolute flat height="48px" color="transparent" v-if="showNav">

      <v-app-bar-nav-icon @click="drawer = !drawer" class="white--text"></v-app-bar-nav-icon>

      <v-spacer></v-spacer>



<!-- LOGO !-->



      <v-toolbar-title @click="$router.push('/')" class="white--text headline">M</v-toolbar-title>

      <v-spacer></v-spacer>



<!-- RIGHT MENU !-->



      <v-menu open-on-hover offset-y transition="scale-transition" origin="top right" content-class="elevation-3 rounded-tr-0"> 
      <template v-slot:activator="{ on, attrs }">

        <v-btn icon color="white" v-bind="attrs" v-on="on"><v-icon>mdi-account-hard-hat</v-icon></v-btn>
        
      </template>
      <v-list flat class="white pa-0">

        <v-list-item-group
        
      >
        
        <v-list-item @click="$router.push('/settings')">

          <v-list-item-content>
            <v-list-item-title class="body-2 grey--text text--darken-1">Settings</v-list-item-title>
          </v-list-item-content>

          <v-list-item-icon>
            <v-icon dense class="grey--text text--darken-1">mdi-account-cog</v-icon>
          </v-list-item-icon>

        </v-list-item>

        <v-list-item @click="logout()">

          <v-list-item-content>
            <v-list-item-title class="body-2 grey--text text--darken-1">Log Out</v-list-item-title>
          </v-list-item-content>

          <v-list-item-icon>
            <v-icon dense class="grey--text text--darken-1">mdi-logout</v-icon>
          </v-list-item-icon>

        </v-list-item>

      </v-list-item-group>

      </v-list>
    </v-menu>

    <!-- <v-btn icon color="white" @click="logout()"><v-icon>mdi-account-hard-hat</v-icon></v-btn> -->

  </v-app-bar>

  <!-- <div>
  <router-view></router-view>
  </div> -->

    <!--<v-main>
    
        <router-view></router-view>
      
    </v-main>-->

          <!-- FOOTER !-->
      

    <!-- <v-bottom-navigation style="height:64px" v-if="showNav">


  </v-bottom-navigation> -->
  
  </v-app>
</template>

<script>
import { mapState } from 'vuex'
import store from '@/store/index.js'
import { cameraCollection } from '@/firebase'

export default {
  components: {
  },
  data: () => ({ 
    drawer: null,
    links: [], 
    site: ""
  }),

  watch:{
    site(){
      
      this.switchSite(this.site.id)
    }
  },

  methods: {
    logout() {
      this.$store.dispatch('logout')
    },
    switchSite(id){
      
      this.$store.dispatch('setLiveSite', id)
    },

  async getCameras() {
      this.inductions = []

      // const docs = await cameraCollection.get()
      const docs = await cameraCollection.where("viewers","array-contains", this.userId ).get()

      docs.forEach(doc => {
        

        let site = {"id":doc.id, "name":doc.data().name, "site":doc.data().site}
        this.sites.push(site) 
      },
      
      this.isFetching = false)
    
    },

  },
  computed: {
    ...mapState(['userProfile', 'posts', 'userRole', 'userId', 'sites', 'liveSite']),
    
    showNav() {
      return Object.keys(this.userId).length > 1
    },
    isAdmin () {
            return store.state.userRole.role === 1;
        }
  },
   beforeMount(){
    //this.getCameras()
  },
}

</script>